import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BaseService } from './base.service';
import { AuthKeycloakService } from './auth-keycloak.service';

@Injectable()
export class UploadImportedService extends BaseService {
  private controller = 'importados';
  constructor(
    private http: HttpClient, 
    protected authKeycloakService: AuthKeycloakService
  ) {
    super(authKeycloakService);
  }
  
}